import React, { FC }          from "react";
import { Card }               from "semantic-ui-react";
import ReservationHistories   from "../../../../domain/reservation/history/ReservationHistories";
import ReservationHistoryCard from "./ReservationHIstoryCard";

type Props = {
  histories: ReservationHistories;
}

const ReservationHistoryCards: FC<Props> = ({histories}) => (
  <>
    <Card.Group>
      { histories.toList().map(history =>
        <ReservationHistoryCard
          history={ history }
          key={ history.reservation.id.value }
        />)
      }
    </Card.Group>
  </>
);

export default ReservationHistoryCards;
